import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'cl-validation-error',
    template: `<ng-template #errorTip let-control>
        @if (control.hasError(fieldName)) {
            {{ control.getError(fieldName) }}
        }
        @if (control.hasError(fieldName)) {
            <br />
        }
        @if (control.hasError('required')) {
            Ievadlauks ir obligāts
        }
        @if (control.hasError('required')) {
            <br />
        }
        @if (control.hasError('maxlength')) {
            Vērtība nedrīkst būt garāka par {{ control.errors.maxlength.requiredLength }} simboliem. Vērības garums:
            {{ control.errors.maxlength.actualLength }}
        }
        @if (control.hasError('maxlength')) {
            <br />
        }
        @if (control.hasError('minlength')) {
            Vērtībai ir jābūt garākai par {{ control.errors.minlength.requiredLength }} simboliem. Vērības garums:
            {{ control.errors.minlength.actualLength }}
        }
        @if (control.hasError('minlength')) {
            <br />
        }
        @if (control.hasError('pattern') || control.hasError('email')) {
            Nepareizs formāts
        }
        @if (control.hasError('pattern') || control.hasError('email')) {
            <br />
        }
        @if (control.hasError('min')) {
            Vērtībai jābūt lielākai par {{ control.errors.min.min }}
        }
        @if (control.hasError('min')) {
            <br />
        }
        @if (control.hasError('max')) {
            Vērtībai jābūt mazākai par {{ control.errors.max.max }}
        }
        @if (control.hasError('max')) {
            <br />
        }
        @if (control.hasError('invalidEmail')) {
            Kādam no norādītajiem e-pastiem ir nepareizs formāts. Nekorektie e-pasti: {{ control.errors.invalidEmail.value.join(', ') }}
        }
        @if (control.hasError('invalidEmail')) {
            <br />
        }
        @if (control.hasError('maxEmails')) {
            Pārsniegts maksimālo norādāmo e-pastu skaits. Maksimālais pieļaujamais skaits: {{ control.errors.maxEmails.value }}
        }
        @if (control.hasError('absenceDatesOverlapping')) {
            Norādītais periods pārklājas ar citu prombūtni
        }
    </ng-template>`,
    standalone: false,
})
export class ValidationErrorComponent {
    @ViewChild('errorTip', { static: true })
    tRef: TemplateRef<any>;

    @Input()
    fieldName: string;

    getTemplateRef(): TemplateRef<any> {
        return this.tRef;
    }
}
